import { cn } from '@rewardops/ui'
import {
  getUrlForMedia,
  type ContentfulImage,
  type ContentfulMediaField,
} from '@rewardops/utils'

type Props = {
  content?: ContentfulMediaField | ContentfulImage | undefined | null
  label: string
  className?: string
  height?: string
  width?: string
  maxHeight?: string
  maxWidth?: string
}

function ContentfulImage(props: Props) {
  const { content, label } = props

  if (!content) return <></>

  const image = content.file.details.image
  const imageSrc = getUrlForMedia(content)

  return (
    <div className={cn('flex justify-center', props.className)}>
      {imageSrc ? (
        <img
          className="object-contain"
          style={{
            maxHeight: props.maxHeight ?? '',
            maxWidth: props.maxWidth ?? '',
          }}
          src={imageSrc}
          width={props.width || image?.width || 0}
          height={props.height || image?.height || 0}
          aria-label={label}
        />
      ) : undefined}
    </div>
  )
}

export default ContentfulImage
